<template>
    <div id="app" class="body">
        <!-- 头部 -->
        <div class="header">
            <div class="logo_img" @click="logoClick">
                <div style="display:flex;justify-content: center;align-items: center;">
                    <!-- <img class="header-img" src="../assets/headPportrait.png"> -->
                    <div style="width: 40px;height: 40px;line-height: 40px;border-radius: 50%;border:3px solid #409eff;text-align: center;font-size: 22px;font-weight: bold;color: #409eff;">{{ $t('common.ao') }}</div>
                </div>
                <div style="display:flex; float:left; height: 65px;">
                    <div class="header-important">
                        <div class="company_name">{{ $t('common.CompanyName') }}</div>
                    </div>
                </div>
            </div>
            <div id="menu_index">
                <!-- web端菜单导航 -->
                <el-menu :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333"
                    style="height: 65px; border:0;" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="1" class="header-title">{{ $t('common.home') }}</el-menu-item>
                    <el-submenu index="2">
                        <template slot="title">
                            <div :title="$t('common.ProductMicrocosmic')" style="overflow: hidden;text-overflow: ellipsis; ">
                                {{ $t('common.ProductMicrocosmic') }}
                            </div>
                        </template>
                        <el-menu-item index="2-2">{{ $t('common.SchedulingManagementSystem') }}</el-menu-item>
                        <el-menu-item index="2-2" disabled>{{ $t('common.IntelligentUnlocking') }}</el-menu-item>
                        <el-menu-item index="2-2" disabled>{{ $t('common.onlineShoppingMall') }}</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="3" class="header-title">{{ $t('common.partner') }}</el-menu-item>
                    <el-menu-item index="4" class="header-title">{{ $t('common.AboutUs') }}</el-menu-item>
                </el-menu>
            </div>
            <div style="font-size: 12px;width: 110px;text-align: center;cursor: pointer;">
                <div v-for="item in languageList" :key="item.key"
                    style="border: 2px solid #409eff; width: 100px;border-radius: 10px;margin-top: 2px;">
                    <div style="" @click="alterLanguage(item.key)">
                        <i style="margin-right:10px">{{ item.key }}</i>
                        <i>{{ item.name }}</i>
                    </div>
                </div>
            </div>
            <!-- <el-dropdown style="width: 300px;display: flex;justify-content: end;">
                <div class="el-dropdown-link" style="line-height: 65px;">
                    {{ $t('common.languageSwitch') }}<i style="margin-left:5px;" class="el-icon-s-tools"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="item in languageList" :key="item.key">
                        <div style="display:flex;justify-content: space-between;" @click="alterLanguage(item.key)">
                            <i style="margin-right:10px">{{ item.key }}</i>
                            <i>{{ item.name }}</i>
                        </div>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
        </div>
        <div :class="$route.name === 'Index' ? '' : 'container'">
            <router-view></router-view>
        </div>
        <div class="footer">
            <div style="width: 70%;margin: 20px auto;display: flex;align-items: center;justify-content: space-between;">
                <div>
                    <div class="footer_font">{{ $t('common.email') }}：macau_power@yahoo.com.hk</div>
                    <div style="margin: auto;" class="footer_font">
                        {{ $t('common.telephone') }}：+853-66677221
                    </div>
                    <div style="margin: auto;" class="footer_font">
                        www.macau-power.com {{ $t('common.CompanyName') }}{{ $t('common.allRightReserved') }}
                    </div>
                </div>
                <div style="display: flex;min-width: 400px;">
                    <img :src="company.qrcode" style="width: 100px;height: 100px;border: 0" />
                    <div class="footer_font" style="margin-left: 20px;line-height: 100px;">{{
                $t('common.contactUs')
            }}
                    </div>
                </div>
            </div>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/launch.png" style="height: 45px;width: 35px" />
        </div>
        <div class="heart-animation-left">{{ $t('common.Macao') }}</div>
        <div class="heart-animation-right">{{ $t('common.BayAreaTechnology') }}</div>
    </div>
</template>

<script>
export default {
    name: "Layout",
    data() {
        return {
            activeIndex: '1',
            company: {
                qrcode: require("../assets/contactUs.jpg"),
            },
            scroll: '',
            timer: '',
            seen: true,
            currentMenu: '首页',
            // 语言数组
            languageList: [
                { name: this.$t('common.simplifiedChinese'), key: 'zhCN' },
                { name: this.$t('common.ChineseTraditional'), key: 'zhTC' },
                { name: this.$t('common.English'), key: 'en' }
            ],
        };
    },
    methods: {
        handleSelect(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    break;
                case '2-2':
                    this.$router.push({ name: "SchedulingManagementSystem" });
                    break;
                case '3':
                    this.$router.push({ name: "Partner" });
                    break;
                case '4':
                    this.$router.push({ name: "AboutUs" });
                    break;
            }
        },
        handleSelectMobile(key) {
            switch (key) {
                case '1':
                    this.$router.push({ name: "Index" });
                    this.currentMenu = '首页';
                    break;
                case '2-1':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品微观";
                    this.currentMenu = '首页';
                    break;
                case '2-2':
                    this.$router.push({ name: "Fruit" });
                    this.currentMenu = '生鲜果蔬';
                    break;
                case '2-3':
                    this.$router.push({ name: "Fashion" });
                    break;
                case '3':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#产品特点";
                    this.currentMenu = '首页';
                    break;
                case '4':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#合作伙伴";
                    this.currentMenu = '首页';
                    break;
                case '5':
                    this.$router.push({ name: "Index" });
                    window.location.hash = "#关于我们";
                    this.currentMenu = '首页';
                    break;
            }
        },
        handleScroll() {
            this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 600) {  //判断滚动后高度超过400px,就显示
                this.$refs.btn.style.display = 'block';
            } else {
                this.$refs.btn.style.display = 'none'
            }
        },
        backTop() {
            const smoothScroll = () => {
                let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (currentScroll > 0) {
                    window.requestAnimationFrame(smoothScroll);
                    window.scrollTo(0, currentScroll - currentScroll / 8);
                }
            };
            smoothScroll();
        },
        login() {
            window.open('https://admin.fastice-tech.com/login')
        },
        register() {
            window.open('https://admin.fastice-tech.com/registe')
        },
        logoClick() {
            this.$router.push({ name: "Index" });
            this.currentMenu = '首页';
        },

        // 修改当前语言
        alterLanguage(key) {
            localStorage.setItem('lang', key)
            this.$i18n.locale = key
            // 修改完要刷新页面才会更新
            this.$router.go(0)
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
        if (this.$route.name == 'SchedulingManagementSystem') {
            this.activeIndex = '2'
        } else if (this.$route.name == 'Partner') {
            this.activeIndex = '3'
        } else if (this.$route.name == 'AboutUs') {
            this.activeIndex = '4'
        } else {
            this.activeIndex = '1'
        }

    },
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
}

.body {
    background-color: #f9fafb;
    color: #409eff;
}

.container {
    padding: 50px 200px;
    box-sizing: border-box;
}

/* 定义动画 */
@keyframes heartbeat {
    0% {
        transform: scale(1);
    }

    /* 初始状态为原大小 */
    50% {
        transform: scale(1.1);
    }

    /* 放大到1.2倍 */
    100% {
        transform: scale(1);
    }

    /* 返回原大小 */
}

/* 应用动画到元素上 */
.heart-animation-left {
    animation: heartbeat 2s infinite;
    position: fixed;
    top: 30%;
    left: 40px;
    width: 20px;
    font-size: 60px;
    color: #fff;
    text-shadow: 5px 5px 10px #409eff;
    /* 设置动画名称、持续时间和重复次数 */
}

.heart-animation-right {
    animation: heartbeat 2s infinite;
    position: fixed;
    top: 15%;
    right: 100px;
    width: 20px;
    font-size: 60px;
    color: #fff;
    text-shadow: 5px 5px 10px #409eff;
    /* 设置动画名称、持续时间和重复次数 */
}

.el-menu {
    background-color: #f9fafb;
}

.el-menu-demo {

    .el-menu-item,
    .el-submenu {
        width: 120px;
        text-align: center;
        font-size: 14px;
        font-size: 14px;
        font-weight: 600;
        color: #409eff !important;
    }

    .el-submenu__title {
        font-size: 14px;
        font-weight: 600;
        color: #409eff !important;
    }
}


.el-dropdown-menu__item {
    padding: 5px;
}

.el-dropdown-link {
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    color: #409eff !important;
}

.logo_img {
    display: flex;
    width: 260px;
    cursor: pointer;
}

#back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer
}

.header-title {
    font-size: 1em;
}

.company_name {
    font-weight: 600;
    font-size: 1em;
}

.footer_font {
    font-size: 1em;
}

#menu_index {
    width: 480px;
    height: 100%
}

.header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 5%;
    height: 65px;
    background-color: #f9fafb;
    box-sizing: border-box;
}

@media screen and (max-device-width: 415px) {
    .logo_img {
        float: left;
        width: auto;
        cursor: pointer;
    }

    #back_to_top {
        position: fixed;
        bottom: 50px;
        right: 5px;
        cursor: pointer
    }

    .footer_font {
        font-size: 0.875em;
    }

    #menu_index {
        float: right;
        width: auto;
        height: 100%
    }

    .mobile_menu {}
}

.header-img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.header-logo {
    height: 50px;
    width: 50px;
    align-self: center;
}

.header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
    width: 300px;
    box-sizing: border-box;
}

.footer {
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    background-color: #eee;
    box-sizing: border-box;
}

a {
    text-decoration: none;
}

a:visited {
    text-decoration: none;
}

a:hover {
    text-decoration: none;
}

a:active {
    text-decoration: none;
}
</style>